module.exports = "<div title=\"{{ctrl.basis | basisOfQuotationDescription}}\">\n    {{ctrl.basis | basisOfQuotationCode}}\n</div>";